import { Role } from "../enums";
import {
  DropdownItem,
  Truck,
  TruckFormData,
  TruckPayload,
  User,
} from "../types";

export class TruckModel {
  public static buildDriverDropdown(users: User[]): DropdownItem[] {
    return users
      .filter((user) => user.roleCode === Role.Driver || user.canDrive)
      .map((user) => ({
        key: `${user.firstName} ${user.lastName}`,
        value: user.id,
      }));
  }

  public static buildTruckPayload(
    data: TruckFormData,
    truck?: Truck,
  ): TruckPayload {
    return {
      name: data.name.trim(),
      licensePlate: data.licensePlate.trim(),
      capacity: Number(data.capacity),
      status: data.status,
      driverId: data.driverId ? Number(data.driverId) : null,
      year: truck?.year ?? null,
      lastServiceDate: truck?.lastServiceDate ?? null,
      nextServiceDate: truck?.nextServiceDate ?? null,
      notes: truck?.notes ?? null,
    };
  }
}
